var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { createElement as _createElement } from "react";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import SelectElection from "@/components/election/SelectElection";
import { EReportElectionPolicy, EReportType, ReportActions, reportTypeConfig } from "@/types/reports";
import { Typography, Autocomplete, Chip, TextField, Box, InputLabel, Alert } from "@mui/material";
import { useContext, useEffect, useMemo, useState } from "react";
import { BooleanInput, Create, SaveButton, SelectInput, SimpleForm, Toolbar, useGetOne, useNotify, useInput, required, } from "react-admin";
import SelectTemplate from "../Template/SelectTemplate";
import { useTranslation } from "react-i18next";
import { useMutation } from "@apollo/client";
import { CREATE_REPORT } from "@/queries/CreateReport";
import { UPDATE_REPORT } from "@/queries/UpdateReport";
import { useFormContext } from "react-hook-form";
import { Cron } from "react-js-cron";
import "react-js-cron/dist/styles.css";
import { ENCRYPT_REPORT } from "@/queries/EncryptReport";
import { IPermissions } from "@/types/keycloak";
import { CustomAutocompleteArrayInput, Dialog } from "@sequentech/ui-essentials";
import { styled } from "@mui/material/styles";
import { AuthContext } from "@/providers/AuthContextProvider";
import { heldByReports, useReportSignatures } from "./ReportSigning";
import { FormStyles } from "@/components/styles/FormStyles";
import { useTimeZoneContext } from "@/components/timezones/useTimeZoneContext";
import { useTimeZoneService } from "@/components/timezones/timeZoneService";
export var EReportEncryption;
(function (EReportEncryption) {
    EReportEncryption["UNENCRYPTED"] = "unencrypted";
    EReportEncryption["CONFIGURED_PASSWORD"] = "configured_password";
})(EReportEncryption || (EReportEncryption = {}));
var InputLabelStyle = styled(InputLabel)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    width: 135px;\n    ", "\n"], ["\n    width: 135px;\n    ", "\n"])), function (_a) {
    var _b = _a.paddingTop, paddingTop = _b === void 0 ? true : _b;
    return paddingTop && "padding-top: 15px;";
});
var InputContainerStyle = styled(Box)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    gap: 12px;\n    width: 100%;\n    align-items: baseline;\n    @media (max-width: ", "px) {\n        flex-direction: column;\n    }\n"], ["\n    display: flex;\n    gap: 12px;\n    width: 100%;\n    align-items: baseline;\n    @media (max-width: ", "px) {\n        flex-direction: column;\n    }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.values.sm;
});
var PasswordInputStyle = styled(FormStyles.PasswordInput)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    flex: 1;\n    margin: 0 auto;\n"], ["\n    flex: 1;\n    margin: 0 auto;\n"])));
var getDefaultPasswordInputData = function () { return ({
    password: "",
    confirmPassword: "",
}); };
var PasswordComponent = function (_a) {
    var report = _a.report, setPassword = _a.setPassword, reportEncryptionPolicy = _a.reportEncryptionPolicy, setReportEncryptionPolicy = _a.setReportEncryptionPolicy;
    var t = useTranslation().t;
    var notify = useNotify();
    var setValue = useFormContext().setValue;
    var _b = useState(false), isDialogOpen = _b[0], setIsDialogOpen = _b[1];
    var _c = useState(getDefaultPasswordInputData()), filePassword = _c[0], setFilePassword = _c[1];
    var reportEncryptionPolicyChoices = Object.keys(EReportEncryption).map(function (key) { return ({
        id: EReportEncryption[key],
        name: t("reportsScreen.reportEncryptionPolicy.".concat(key)),
    }); });
    var onChangePolicy = function (value) {
        if (reportEncryptionPolicy === value) {
            return;
        }
        if (EReportEncryption.UNENCRYPTED === value) {
            setReportEncryptionPolicy(value);
            setPassword(null);
        }
        else {
            setIsDialogOpen(true);
        }
    };
    var checkIsValidPassword = function () {
        return filePassword.password === filePassword.confirmPassword && !!filePassword.password;
    };
    var handleCloseDialog = function (value) {
        var isValidPassword = checkIsValidPassword();
        if (!value || !isValidPassword) {
            setPassword(null);
            setReportEncryptionPolicy(EReportEncryption.UNENCRYPTED);
            setValue("encryption_policy", EReportEncryption.UNENCRYPTED);
            if (!isValidPassword && filePassword.password) {
                notify(t("reportsScreen.messages.passwordMismatch"), { type: "error" });
            }
        }
        else {
            setPassword(filePassword.password);
            setReportEncryptionPolicy(EReportEncryption.CONFIGURED_PASSWORD);
            setValue("encryption_policy", EReportEncryption.CONFIGURED_PASSWORD);
        }
        setIsDialogOpen(false);
        setFilePassword(getDefaultPasswordInputData());
    };
    var handleChangePassword = function (event) {
        setFilePassword(__assign(__assign({}, filePassword), { password: event.target.value }));
    };
    var handleChangeConfirmPassword = function (event) {
        setFilePassword(__assign(__assign({}, filePassword), { confirmPassword: event.target.value }));
    };
    var equalToPassword = function (value, allValues) {
        if (!allValues.password || allValues.password.length == 0) {
            return;
        }
        if (value !== allValues.password) {
            return t("usersAndRolesScreen.users.fields.passwordMismatch");
        }
    };
    return (_jsxs(_Fragment, { children: [_jsx(SelectInput, { label: String(t("reportsScreen.reportEncryptionPolicy.title")), source: "encryption_policy", defaultValue: EReportEncryption.UNENCRYPTED, choices: reportEncryptionPolicyChoices, disabled: (report === null || report === void 0 ? void 0 : report.encryption_policy) === EReportEncryption.CONFIGURED_PASSWORD, onChange: function (event) {
                    onChangePolicy(event.target.value);
                }, value: reportEncryptionPolicy !== null && reportEncryptionPolicy !== void 0 ? reportEncryptionPolicy : EReportEncryption.UNENCRYPTED, isRequired: true }), _jsx(Dialog, { variant: "info", open: isDialogOpen, handleClose: handleCloseDialog, okEnabled: checkIsValidPassword, "aria-labelledby": "password-dialog-title", title: String(t("electionEventScreen.export.passwordTitle")), ok: String(t("usersAndRolesScreen.users.fields.savePassword")), children: _jsxs(_Fragment, { children: [_jsxs(InputContainerStyle, { children: [_jsxs(InputLabelStyle, { children: [t("usersAndRolesScreen.users.fields.password"), ":"] }), _jsx(PasswordInputStyle, { label: false, source: "password", onChange: handleChangePassword, value: filePassword.password })] }), _jsxs(InputContainerStyle, { children: [_jsxs(InputLabelStyle, { children: [t("usersAndRolesScreen.users.fields.repeatPassword"), ":"] }), _jsx(PasswordInputStyle, { label: false, source: "confirmPassword", validate: equalToPassword, onChange: handleChangeConfirmPassword, value: filePassword.confirmPassword })] })] }) })] }));
};
export var EditReportForm = function (_a) {
    var close = _a.close, tenantId = _a.tenantId, electionEventId = _a.electionEventId, isEditReport = _a.isEditReport, reportId = _a.reportId;
    var t = useTranslation().t;
    var notify = useNotify();
    var _b = useState(EReportEncryption.UNENCRYPTED), reportEncryptionPolicy = _b[0], setReportEncryptionPolicy = _b[1];
    var createReport = useMutation(CREATE_REPORT)[0];
    var updateReport = useMutation(UPDATE_REPORT)[0];
    var encryptReport = useMutation(ENCRYPT_REPORT, {
        context: {
            headers: {
                "x-hasura-role": IPermissions.REPORT_WRITE,
            },
        },
    })[0];
    var _c = useState(null), password = _c[0], setPassword = _c[1];
    var _d = useState(false), isCronActive = _d[0], setIsCronActive = _d[1];
    var _e = useState("00 8 * * 1,2,3,4,5"), cronValue = _e[0], setCronValue = _e[1];
    var _f = useState(false), enabled = _f[0], setEnabled = _f[1];
    var authContext = useContext(AuthContext);
    var report = useGetOne("sequent_backend_report", { id: reportId }, { enabled: isEditReport }).data;
    useEffect(function () {
        if (undefined === reportEncryptionPolicy && (report === null || report === void 0 ? void 0 : report.encryption_policy)) {
            setReportEncryptionPolicy(report.encryption_policy);
        }
    }, [report === null || report === void 0 ? void 0 : report.encryption_policy, reportEncryptionPolicy]);
    var handleSubmit = function (values) { return __awaiter(void 0, void 0, void 0, function () {
        var formValues, expr, emails, formData, hasPassword, reportData, error_1;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    formValues = __assign({}, values);
                    if ("confirmPassword" in formValues) {
                        delete formValues.confirmPassword;
                    }
                    if ("password" in formValues) {
                        delete formValues.password;
                    }
                    if (isCronActive) {
                        expr = (_a = values.cron_config) === null || _a === void 0 ? void 0 : _a.cron_expression;
                        emails = ((_b = values.cron_config) === null || _b === void 0 ? void 0 : _b.email_recipients) || [];
                        if (!expr) {
                            notify("Please configure a cron schedule before saving", { type: "error" });
                            return [2 /*return*/];
                        }
                        if (emails.length === 0) {
                            notify("Please enter at least one e-mail recipient", { type: "error" });
                            return [2 /*return*/];
                        }
                    }
                    formData = __assign(__assign({}, formValues), { encryption_policy: reportEncryptionPolicy, tenant_id: tenantId, election_event_id: electionEventId, cron_config: isCronActive
                            ? {
                                is_active: true,
                                cron_expression: cronValue,
                                email_recipients: values.cron_config.email_recipients,
                                executer_username: authContext.username,
                            }
                            : null });
                    hasPassword = !!password;
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 9, , 10]);
                    if (!(isEditReport && reportId)) return [3 /*break*/, 5];
                    return [4 /*yield*/, updateReport({
                            variables: {
                                id: reportId,
                                set: formData,
                            },
                        })];
                case 2:
                    _c.sent();
                    if (!hasPassword) return [3 /*break*/, 4];
                    return [4 /*yield*/, encryptReport({
                            variables: {
                                electionEventId: electionEventId,
                                reportId: reportId,
                                password: password,
                            },
                            onCompleted: function (data) { return __awaiter(void 0, void 0, void 0, function () {
                                var _a;
                                return __generator(this, function (_b) {
                                    if ((_a = data.encrypt_report) === null || _a === void 0 ? void 0 : _a.error_msg) {
                                        notify(data.encrypt_report.error_msg, { type: "error" });
                                    }
                                    return [2 /*return*/];
                                });
                            }); },
                            onError: function (error) {
                                console.log(error);
                                notify(t("reportsScreen.messages.createError"), { type: "error" });
                            },
                        })];
                case 3:
                    _c.sent();
                    _c.label = 4;
                case 4:
                    notify(t("reportsScreen.messages.updateSuccess"), { type: "success" });
                    return [3 /*break*/, 8];
                case 5: return [4 /*yield*/, createReport({
                        variables: {
                            object: formData,
                        },
                    })];
                case 6:
                    reportData = (_c.sent()).data;
                    notify(t("reportsScreen.messages.createSuccess"), { type: "success" });
                    if (!(reportData && hasPassword)) return [3 /*break*/, 8];
                    return [4 /*yield*/, encryptReport({
                            variables: {
                                reportId: reportData.insert_sequent_backend_report.returning[0].id,
                                electionEventId: electionEventId,
                                password: password,
                            },
                            onCompleted: function (data) {
                                var _a;
                                if ((_a = data.encrypt_report) === null || _a === void 0 ? void 0 : _a.error_msg) {
                                    notify(data.encrypt_report.error_msg, { type: "error" });
                                }
                                else {
                                    notify(t("reportsScreen.messages.encryptSuccess"), {
                                        type: "success",
                                    });
                                }
                            },
                            onError: function (error) {
                                notify(t("reportsScreen.messages.encryptError"), { type: "error" });
                            },
                        })];
                case 7:
                    _c.sent();
                    _c.label = 8;
                case 8:
                    if (close) {
                        close();
                    }
                    return [3 /*break*/, 10];
                case 9:
                    error_1 = _c.sent();
                    notify(t("reportsScreen.messages.submitError"), { type: "error" });
                    return [3 /*break*/, 10];
                case 10: return [2 /*return*/];
            }
        });
    }); };
    return (_jsx(Create, { hasEdit: isEditReport, children: _jsxs(SimpleForm, { record: isEditReport ? report : undefined, onSubmit: handleSubmit, toolbar: _jsx(Toolbar, { children: _jsx(SaveButton, { alwaysEnable: enabled }) }), children: [_jsx(FormContent, { tenantId: tenantId, electionEventId: electionEventId, isEditReport: isEditReport, report: report, doCronActive: function (value) { return setIsCronActive(value); }, cronValue: cronValue, setCronValue: setCronValue, setEnabled: setEnabled }), _jsx(PasswordComponent, { report: report, setPassword: setPassword, reportEncryptionPolicy: reportEncryptionPolicy, setReportEncryptionPolicy: setReportEncryptionPolicy })] }) }));
};
var EmailRecipientsInput = function (props) {
    var _a = useInput(props), field = _a.field, // Contains value and onChange
    fieldState = _a.fieldState, // Contains error and touched
    isRequired = _a.isRequired, id = _a.id;
    var label = props.label, placeholder = props.placeholder, onChange = props.onChange;
    return (_jsx(Autocomplete, { multiple: true, freeSolo: true, options: [], value: field.value || [], onChange: function (event, newValue) {
            field.onChange(newValue || []);
            if (onChange) {
                onChange(newValue || []); // Call the passed onChange prop
            }
        }, fullWidth: true, renderTags: function (value, getTagProps) {
            return value.map(function (option, index) { return (_createElement(Chip, __assign({ label: option }, getTagProps({ index: index }), { key: index }))); });
        }, renderInput: function (params) {
            var _a;
            return (_jsx(TextField, __assign({}, params, { variant: "outlined", label: label, placeholder: placeholder, error: fieldState.invalid, helperText: (_a = fieldState.error) === null || _a === void 0 ? void 0 : _a.message, required: isRequired, id: id })));
        } }));
};
var PermissionLabelsInput = function (props) {
    var _a;
    var _b = useInput(__assign(__assign({}, props), { source: "permission_label" })), field = _b.field, fieldState = _b.fieldState, isRequired = _b.isRequired, id = _b.id;
    // Initialize local choices state if not provided in props
    var _c = useState(props.choices || []), internalChoices = _c[0], setInternalChoices = _c[1];
    var choices = props.choices || internalChoices;
    // Update form value when choices change
    var handleChange = function (newValue) {
        field.onChange(newValue);
        // Also update choices if needed
        if (props.setChoices) {
            props.setChoices(newValue.map(function (label) { return ({ id: label, name: label }); }));
        }
    };
    // Handle creating new entries
    var handleCreate = function (newValue) {
        if (newValue && !choices.find(function (choice) { return choice.id === newValue; })) {
            var newChoice = { id: newValue, name: newValue };
            var updatedChoices = __spreadArray(__spreadArray([], choices, true), [newChoice], false);
            // Update local state if no external state management provided
            if (!props.setChoices) {
                setInternalChoices(updatedChoices);
            }
            else {
                props.setChoices(updatedChoices);
            }
            // Ensure the field value includes the new item
            var currentValue = field.value || [];
            if (!currentValue.includes(newValue)) {
                field.onChange(__spreadArray(__spreadArray([], currentValue, true), [newValue], false));
            }
        }
        return { id: newValue, name: newValue };
    };
    return (_jsx(CustomAutocompleteArrayInput, { label: (_a = props.label) !== null && _a !== void 0 ? _a : "", defaultValue: field.value || [], onChange: handleChange, onCreate: handleCreate, choices: choices }));
};
var ReportTypeInput = function (props) {
    var _a = useInput(props), field = _a.field, fieldState = _a.fieldState, isRequired = _a.isRequired, id = _a.id;
    var choices = props.choices, label = props.label, onChange = props.onChange; // Destructure 'onChange'
    return (_jsx(Autocomplete, { fullWidth: true, options: choices, getOptionLabel: function (option) { return option.name; }, onChange: function (event, newValue) {
            field.onChange(newValue ? newValue.id : null);
            if (onChange) {
                onChange(newValue ? newValue.id : null); // Call the passed onChange prop
            }
        }, value: choices.find(function (choice) { return choice.id === field.value; }) || null, renderInput: function (params) {
            var _a;
            return (_jsx(TextField, __assign({}, params, { label: label !== null && label !== void 0 ? label : "", variant: "outlined", required: isRequired, error: fieldState.invalid, helperText: (_a = fieldState.error) === null || _a === void 0 ? void 0 : _a.message, id: id })));
        } }));
};
var FormContent = function (_a) {
    var _b, _c;
    var tenantId = _a.tenantId, electionEventId = _a.electionEventId, isEditReport = _a.isEditReport, report = _a.report, doCronActive = _a.doCronActive, cronValue = _a.cronValue, setCronValue = _a.setCronValue, setEnabled = _a.setEnabled;
    var t = useTranslation().t;
    var _d = useState(undefined), reportType = _d[0], setReportType = _d[1];
    var _e = useState(undefined), electionId = _e[0], setElectionId = _e[1];
    var _f = useState(undefined), templateAlias = _f[0], setTemplateAlias = _f[1];
    var _g = useState(false), isCronActive = _g[0], setIsCronActive = _g[1];
    // Scheduled reports run in the event's primary zone (design §7).
    var zones = useTimeZoneContext(electionEventId);
    var timeZones = useTimeZoneService();
    var _h = useFormContext(), setValue = _h.setValue, register = _h.register;
    useEffect(function () {
        register("cron_config.cron_expression");
    }, [register]);
    useEffect(function () {
        var _a, _b, _c;
        console.log("report changed");
        setIsCronActive(((_a = report === null || report === void 0 ? void 0 : report.cron_config) === null || _a === void 0 ? void 0 : _a.is_active) || false);
        setCronValue === null || setCronValue === void 0 ? void 0 : setCronValue(((_b = report === null || report === void 0 ? void 0 : report.cron_config) === null || _b === void 0 ? void 0 : _b.cron_expression) || "");
        setReportType((report === null || report === void 0 ? void 0 : report.report_type) ? report.report_type : undefined);
        setTemplateAlias((report === null || report === void 0 ? void 0 : report.template_alias) || undefined);
        setValue("template_alias", (report === null || report === void 0 ? void 0 : report.template_alias) || undefined);
        setValue("report_type", (report === null || report === void 0 ? void 0 : report.report_type) ? report.report_type : undefined);
        setValue("cron_config.email_recipients", ((_c = report === null || report === void 0 ? void 0 : report.cron_config) === null || _c === void 0 ? void 0 : _c.email_recipients) || []);
        setValue("permission_label", (report === null || report === void 0 ? void 0 : report.permission_label) || []);
    }, [report, setValue, setCronValue]);
    useEffect(function () {
        doCronActive === null || doCronActive === void 0 ? void 0 : doCronActive(isCronActive);
    }, [isCronActive, doCronActive]);
    var reportTypeChoices = Object.values(EReportType)
        .sort()
        .map(function (reportType) { return ({
        id: reportType,
        name: t("template.type.".concat(reportType)),
    }); });
    var signatures = useReportSignatures(String(electionEventId !== null && electionEventId !== void 0 ? electionEventId : ""));
    var requiresSigningPost = !!reportType && heldByReports(reportType) && ((_b = signatures.needs(reportType)) !== null && _b !== void 0 ? _b : 0) > 0;
    var electionPolicy = useMemo(function () {
        var _a;
        if (requiresSigningPost)
            return EReportElectionPolicy.ELECTION_REQUIRED;
        if (!reportType) {
            return EReportElectionPolicy.ELECTION_ALLOWED;
        }
        return (_a = reportTypeConfig[reportType].electionPolicy) !== null && _a !== void 0 ? _a : EReportElectionPolicy.ELECTION_ALLOWED;
    }, [reportType, requiresSigningPost]);
    var isTemplateRequired = useMemo(function () {
        var _a;
        if (!reportType) {
            return false;
        }
        return (_a = reportTypeConfig[reportType].templateRequired) !== null && _a !== void 0 ? _a : false;
    }, [reportType]);
    var canGenerateReportScheduled = useMemo(function () {
        if (!reportType) {
            return false;
        }
        return reportTypeConfig[reportType].actions.includes(ReportActions.GENERATE_SCHEDULED);
    }, [reportType]);
    useEffect(function () {
        if (reportType) {
            setValue("report_type", reportType);
        }
    }, [reportType, setValue]);
    useEffect(function () {
        if ((report === null || report === void 0 ? void 0 : report.election_id) && electionPolicy === EReportElectionPolicy.ELECTION_NOT_ALLOWED) {
            setElectionId(null);
            setValue("election_id", null);
        }
    }, [electionPolicy]);
    useEffect(function () {
        var _a, _b;
        // Reset the isCronActive state when the report type changes
        if (!canGenerateReportScheduled) {
            setIsCronActive(false);
        }
        else {
            setIsCronActive((_b = (_a = report === null || report === void 0 ? void 0 : report.cron_config) === null || _a === void 0 ? void 0 : _a.is_active) !== null && _b !== void 0 ? _b : false);
        }
    }, [reportType, canGenerateReportScheduled, report]);
    var handleCronToggle = function (event) {
        setIsCronActive(event.target.checked);
    };
    var handleReportTypeChange = function (newValue) {
        setReportType(newValue || undefined);
        setTemplateAlias(null);
        setValue("template_alias", null);
        setValue("report_type", newValue);
    };
    var _j = useState([]), permissionLabels = _j[0], setPermissionLabels = _j[1];
    var _k = useState([]), permissionLabelChoices = _k[0], setPermissionLabelChoices = _k[1];
    useEffect(function () {
        if (report === null || report === void 0 ? void 0 : report.permission_label) {
            var choices_1 = report.permission_label.map(function (label) { return ({
                id: label,
                name: label,
            }); });
            setPermissionLabelChoices(choices_1);
        }
    }, [report === null || report === void 0 ? void 0 : report.permission_label]);
    var handlePermissionLabelRemoved = function (value) {
        if ((value === null || value === void 0 ? void 0 : value.length) < (permissionLabels === null || permissionLabels === void 0 ? void 0 : permissionLabels.length)) {
            setValue("permission_label", value);
        }
    };
    var handlePermissionLabelChanged = function (value) {
        setValue("permission_label", value);
        setPermissionLabels(value);
    };
    var handlePermissionLabelAdded = function (value) {
        setValue("permission_label", value);
    };
    return (_jsxs(_Fragment, { children: [_jsx(Typography, { variant: "h4", children: isEditReport ? t("reportsScreen.edit.title") : t("reportsScreen.create.title") }), _jsx(Typography, { variant: "body2", children: isEditReport
                    ? t("reportsScreen.edit.subtitle")
                    : t("reportsScreen.create.subtitle") }), _jsx(ReportTypeInput, { source: "report_type", label: String(t("template.form.type")), choices: reportTypeChoices, isRequired: true, onChange: handleReportTypeChange }), requiresSigningPost && (_jsx(Alert, { severity: "info", children: t("signing.reports.postRequired") })), _jsx(SelectElection, { tenantId: tenantId, electionEventId: electionEventId, label: String(t("reportsScreen.fields.electionId")), onSelectElection: function (electionId) { return setElectionId(electionId); }, source: "election_id", value: electionId, isRequired: electionPolicy === EReportElectionPolicy.ELECTION_REQUIRED, validate: requiresSigningPost ? required() : undefined, disabled: electionPolicy === EReportElectionPolicy.ELECTION_NOT_ALLOWED }), _jsx(SelectTemplate, { tenantId: tenantId, templateType: reportType ? (_c = reportTypeConfig[reportType]) === null || _c === void 0 ? void 0 : _c.associatedTemplateType : undefined, source: "template_alias", label: String(t("reportsScreen.fields.template")), onSelectTemplate: function (template) {
                    console.log("Selected templateId:", template.alias);
                    setTemplateAlias(template.alias);
                }, value: templateAlias, isRequired: isTemplateRequired }), _jsx(PermissionLabelsInput, { label: String(t("usersAndRolesScreen.users.fields.permissionLabel")), choices: permissionLabelChoices, setChoices: setPermissionLabelChoices, source: "permission_label" }), canGenerateReportScheduled && (_jsx(BooleanInput, { source: "cron_config.is_active", label: String(t("reportsScreen.fields.repeatable")), onChange: handleCronToggle })), isCronActive && (_jsxs(_Fragment, { children: [_jsx(Cron, { value: cronValue !== null && cronValue !== void 0 ? cronValue : "", setValue: function (newValue) {
                            console.log("new cron config: ".concat(newValue));
                            setValue("cron_config.cron_expression", newValue, {
                                shouldDirty: true,
                                shouldTouch: true,
                            });
                            setCronValue === null || setCronValue === void 0 ? void 0 : setCronValue(newValue);
                            if (newValue !== cronValue) {
                                setEnabled === null || setEnabled === void 0 ? void 0 : setEnabled(true);
                            }
                        } }), _jsx(Typography, { variant: "body2", color: "text.secondary", "data-testid": "cron-zone", children: t("lifecycle.input.cronZone", {
                            zone: timeZones.timeZoneOption(zones.primary, timeZones.text).label,
                        }) }), _jsx(EmailRecipientsInput, { source: "cron_config.email_recipients", label: String(t("reportsScreen.fields.emailRecipients")), placeholder: t("reportsScreen.fields.emailRecipientsPlaceholder"), isRequired: false, onChange: function (newValue) {
                            setValue("cron_config.email_recipients", newValue);
                        } })] }))] }));
};
var templateObject_1, templateObject_2, templateObject_3;
